import React, { useEffect } from "react";
import { HashRouter as Router, Route, useLocation } from "react-router-dom";

import '@csstools/normalize.css';
import './App.css';

import HomePage from "./pages/home"
import MastersPage from "./pages/masters"
// import SponsorsPage from "./pages/sponsors"
import PhilharmonicPage from "./pages/philharmonic"
import StudentsPage from "./pages/students"
import ContactPage from "./pages/contact"
import CovidPage from "./pages/covid"
import FaqPage from "./pages/faq"
import SubscribePage from "./pages/subscribe"
import ShowPage from "./pages/show"
import FestivalPage from "./pages/festival"

import ReactGA from "react-ga4";
ReactGA.initialize("G-THHYTX4Y9V");

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {  
  return (
    <Router>
        <ScrollToTop />
        <Route exact path="/" component={HomePage} />
        <Route exact path="/speaker-series" component={MastersPage} />
        {/* <Route exact path="/sponsors" component={SponsorsPage} /> */}
        <Route exact path="/philharmonic" component={PhilharmonicPage} />
        <Route exact path="/students" component={StudentsPage} />
        <Route exact path="/contact" component={ContactPage} />
        <Route exact path="/covid" component={CovidPage} />
        <Route exact path="/faq" component={FaqPage} />
        <Route exact path="/subscribe" component={SubscribePage} />
        <Route path='/shows/:name?' component={ShowPage} />
        <Route path='/festival/:name?' component={FestivalPage} />
    </Router>
  )  
}

function MarshallArtistsSeries() {
  return (
    <App />
  );
}

export default MarshallArtistsSeries;